
import * as constants from '../Constatnts'
import axios from 'axios';



export function getHelpDeskConfiguration(registrationId) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        constants.API_URL + `/helpdesk/configuration/${registrationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.data || {};
      }

      return [];
    } catch (error) {
      return [];
    }
  };
}


export function saveHelpDeskConfiguration(data, key = "") {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key) {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/helpdesk/configuration/${key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/helpdesk/configuration`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getHelpDeskType(registrationId) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        constants.API_URL + `/helpdesk/type/${registrationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.data || {};
      }

      return [];
    } catch (error) {
      return [];
    }
  };
}


export function deleteHelpDeskType(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        constants.API_URL + `/helpdesk/type/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.data || {};
      }

      return [];
    } catch (error) {
      return [];
    }
  };
}

export function saveHelpDeskType(data, key = "") {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key) {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/helpdesk/type/${key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/helpdesk/type`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getHelpDeskTickets(
  registrationId,
  storeId,
  status,
  customerName,
  customerPhoneNo,
  customerEmail,
  fromDate,
  toDate,
  ticketNo
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const queryParams = new URLSearchParams();

      if (storeId) {
        queryParams.append("storeId", storeId);
      }

      if (status) {
        queryParams.append("status", status);
      }

        if (ticketNo) {
        queryParams.append("ticketNo", ticketNo);
      }

      if (customerName) {
        queryParams.append("customerName", customerName);
      }

      if (customerPhoneNo) {
        queryParams.append("customerPhoneNo", customerPhoneNo);
      }

      if (customerEmail) {
        queryParams.append("customerEmail", customerEmail);
      }

      if (fromDate) {
        queryParams.append("fromDate", fromDate);
      }

      if (toDate) {
        queryParams.append("toDate", toDate);
      }

      const queryString = queryParams.toString();

      const url =
        `${constants.API_URL}/helpdesk/ticket/${registrationId}` +
        (queryString ? `?${queryString}` : "");

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

        return response.data;
    } catch (error) {
      console.error("Error fetching tickets:", error);
      return [];
    }
  };
}

export function sendHelpDeskTicketMessage(id,data) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};
        response = await axios.post(
          `${constants.API_URL}/helpdesk/ticket/message/${id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

    
          return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function updateHelpDeskTicket(id,data) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};
        response = await axios.put(
          `${constants.API_URL}/helpdesk/ticket/${id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

    
          return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function saveTicket(data) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};
        response = await axios.post(
          `${constants.API_URL}/helpdesk/ticket`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

    
          return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}